<template>
	<ul class="radio-opciones" v-if="loaded === 'true'">
		<li class="streamsaudio">
			<button class="online paused">
				<div class="btn gradient">
					<i class="icon icon-radio"></i>
				</div>
				<span>Radio Online</span> 
			</button>


			<a href="#"><i class="fa fa-chevron-down"></i></a>


			<ul id="lista_streams" v-if="loadedstreams === 'true'">
				<li v-for="stream in streams">
					<a href="#" class="obj-cont" :stream_url="stream.stream_url" :stream_title="stream.title.rendered">
						<img v-if="stream.better_featured_image.media_details.sizes.thumbnail.source_url !== null" v-bind:src="stream.better_featured_image.media_details.sizes.thumbnail.source_url" alt="" class="obj-img">
						<img v-else v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="" class="obj-img">
					</a>

				</li>
			</ul>
		</li>
		<li class="actual">
			<router-link :to="{ name: 'programa', params: { elprograma: programas.actual.post_name }}">
				<figure class="obj-cont actual__img" v-if="programas.actual.meta.images['50x50'] !== null">
					<img v-bind:src="programas.actual.meta.images['50x50']" class="obj-img">
				</figure>
				<figure class="obj-cont actual__img" v-else>
					<img v-bind:src="theme_url+'/html/assets/img/novedad.jpg'" class="obj-img">
				</figure>

				<div class="actual__desc">
					<h3>Programa Actual</h3>
					<p>{{ programas.actual.post_title }}</p>
				</div>
			</router-link>
		</li>
		<li class="proximamente">
			<a href="#">Proximamente <i class="fa fa-chevron-down"></i></a>
			<ul>

				<li v-for="programa in programas.proximos">
					<router-link :to="{ name: 'programa', params: { elprograma: programa.post_name }}" class="obj-cont">
						<img v-if="programa.meta.images['805x773'] !== null" v-bind:src="programa.meta.images['805x773']" alt="" class="obj-img">
						<img v-else v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="" class="obj-img">
					</router-link>
				</li>

				<li>
					<router-link :to="{ name: 'programas'}" class="obj-cont">
						VER PROGRAMACION COMPLETA
					</router-link>
				</li>

			</ul>
		</li>
	</ul>
</template>

<script>
export default {
	mounted: function() {
		
		this.getStreams();
	},
	data() {
		return {
			programas: [],
			streams: [],
			site_name: rtwp.site_name,
			theme_url: rtwp.theme_url,
			loaded: 'false',
			loadedstreams: 'false',
		};
	},
	methods: {
		getProgramas: function() {
			const vm = this;
			vm.$http.get( 'prox_programa/v1' )
			.then( ( res ) => {
				vm.programas = res.data;
				vm.loaded = 'true';
				vm.$nextTick(function () {
					jQuery('ul.radio-opciones').on('click', 'button.online', function(event) {
						event.preventDefault();
						obedira_playaudio();
					});
					// MENU
					jQuery(".proximamente > a").click(function(){
						jQuery(this).parent().toggleClass("opened");
						jQuery(".proximamente > ul").fadeToggle();
					});
					setTimeout(function () {
						this.getProgramas();
					}.bind(this), (1000 * 60 * 10));

					init_attach();
				});
			} )
			.catch( ( res ) => {
				console.log( 'Something went wrong :'+res );
			} );
		},
		getStreams: function(){
			this.getProgramas();
			const vm = this;
			vm.$http.get( '/wp/v2/streams?order=asc&orderby=menu_order' )
			.then( ( res ) => {
				vm.streams = res.data;
				vm.loadedstreams = 'true';
				vm.$nextTick(function () {
					// MENU STREAMING
					setTimeout(function(){					
						jQuery(".streamsaudio > a").click(function(){
							jQuery(this).parent().toggleClass("opened");
							jQuery(".streamsaudio > ul").fadeToggle();
						});
					},1000);

				});
			} )
			.catch( ( res ) => {
				console.log( 'Something went wrong :'+res );
			} );
		}
	}
};
</script>



// WEBPACK FOOTER //
// proximosprogramas.vue?a557df4c